import { render, staticRenderFns } from "./providerTodayPrice.vue?vue&type=template&id=05a57b06&scoped=true&"
import script from "./providerTodayPrice.vue?vue&type=script&lang=babel&"
export * from "./providerTodayPrice.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a57b06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
